export default "__VITE_ASSET__Da9mamZP__"